import $ from "jquery";
import {DataLayer} from "./DataLayer";
import {FineDetailsLayer} from "./FineDetailsLayer";
import {FAQS} from "../Api/Types";

export class FAQSLayer extends FineDetailsLayer {

    private PopulateFaqs(faqs: FAQS[]) {
        const faq_container = $('#faqs-container');
        for (const faq of faqs) {
            const faq_template = $(DataLayer.templates["details-template"]);
            faq_template.find('[data-content-type="faqs-question"]').text(faq.question);
            faq_template.find('[data-content-type="faqs-answer"]').html(faq.answer);
            faq_container.append(faq_template);
        }
    }

    protected OnFAQS() {
        this.client.get_faqs().done(x => {
            this.PopulateFaqs(x);
        });
    }
}
